// extracted by mini-css-extract-plugin
export default {"grid":"TaskList_grid__-cPep","card":"TaskList_card__iJU2p"};